import { configureStore } from "@reduxjs/toolkit";
import GrowerReducer from "./reducers/GrowerReducer";
import ConfigurationReducer from "./reducers/ConfigurationReducer";

export const Store = configureStore({
    reducer: {
        growerReducer: GrowerReducer,
        configurationReducer: ConfigurationReducer,
    },

})